import { h } from "@stencil/core";
import { tableClass } from "../constants";
export const TableDataHeader = ({ group = false, sortable = false, label = "", sortField = "" }, children) => (h("th", { class: {
        [`${tableClass}__th`]: true,
        [`${tableClass}__th--group`]: group
    }, scope: "col" }, sortable && label !== "" && (
// @ts-expect-error Check for typing
h("ux-table-data-sort", { sortField: sortField !== "" ? sortField : null }, label)), !sortable && label !== "" && label, children));
//# sourceMappingURL=table-data-header.js.map
